// theme/assets/shop-by-vehicle-core.js
/**
 * TFS Shop-by-Vehicle — pure, DOM-free decision helpers.
 *
 * UMD: attaches window.TFSShopByVehicleCore on the storefront and is
 * require()-able as CommonJS in Vitest (see server/__tests__/shopByVehicleCore.test.mjs).
 *
 * Owner rule encoded here: a step with <=1 option is auto-resolved and never
 * prompted. "Drive" is the fitment `chassis` field (4WD/AWD/FWD/RWD).
 */
(function (root, factory) {
  if (typeof module === 'object' && module.exports) {
    module.exports = factory();
  } else {
    root.TFSShopByVehicleCore = factory();
  }
}(typeof window !== 'undefined' ? window : (typeof globalThis !== 'undefined' ? globalThis : this), function () {
  'use strict';

  var STANDARD_LABEL = 'Standard';

  // 'tires' only when explicitly tires; everything else defaults to 'wheels'.
  function normalizeCatalog(raw) {
    return String(raw || '').toLowerCase() === 'tires' ? 'tires' : 'wheels';
  }

  // Distinct submodels in first-seen order; '' → { value:'', label:'Standard' }.
  function buildSubmodelOptions(records) {
    var seen = {};
    var out = [];
    (records || []).forEach(function (r) {
      var s = (r && r.submodel) || '';
      if (!Object.prototype.hasOwnProperty.call(seen, s)) {
        seen[s] = true;
        out.push({ value: s, label: s === '' ? STANDARD_LABEL : s });
      }
    });
    return out;
  }

  // Distinct drivetrains (chassis) among records matching the chosen submodel.
  function deriveDrives(records, submodel) {
    var sub = submodel == null ? '' : String(submodel);
    var seen = {};
    var out = [];
    (records || []).forEach(function (r) {
      if (!r) return;
      if (((r.submodel) || '') !== sub) return;
      var c = ((r.chassis) || '').trim();
      if (c && !Object.prototype.hasOwnProperty.call(seen, c)) { seen[c] = true; out.push(c); }
    });
    return out;
  }

  // Matching vehicle id for a submodel (+ optional drive). Exact submodel+chassis
  // first, then submodel-only, then the first record. Returns null if none.
  function resolveVehicleId(records, submodel, drive) {
    var sub = submodel == null ? '' : String(submodel);
    var dr = drive == null ? '' : String(drive);
    var list = records || [];
    var i, r;
    for (i = 0; i < list.length; i++) {
      r = list[i];
      if (((r.submodel) || '') === sub && ((r.chassis) || '') === dr) return r.id != null ? r.id : null;
    }
    for (i = 0; i < list.length; i++) {
      r = list[i];
      if (((r.submodel) || '') === sub) return r.id != null ? r.id : null;
    }
    return list.length ? (list[0].id != null ? list[0].id : null) : null;
  }

  // Destination collection URL with the params the fitment app consumes.
  // Blank submodel/chassis are omitted; vehicleId falls back to id.
  function buildResultUrl(catalog, vehicle) {
    var cat = normalizeCatalog(catalog);
    var v = vehicle || {};
    var parts = [];
    function add(k, val) {
      if (val !== undefined && val !== null && String(val) !== '') {
        parts.push(encodeURIComponent(k) + '=' + encodeURIComponent(val));
      }
    }
    add('year', v.year);
    add('make', v.make);
    add('model', v.model);
    add('submodel', v.submodel);
    add('chassis', v.chassis);
    add('vehicleId', v.vehicleId != null ? v.vehicleId : v.id);
    return '/collections/' + cat + (parts.length ? '?' + parts.join('&') : '');
  }

  return {
    STANDARD_LABEL: STANDARD_LABEL,
    normalizeCatalog: normalizeCatalog,
    buildSubmodelOptions: buildSubmodelOptions,
    deriveDrives: deriveDrives,
    resolveVehicleId: resolveVehicleId,
    buildResultUrl: buildResultUrl,
  };
}));
